var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('div',{staticClass:"entity-icon",style:({ width: `${_vm.width}px`, height: `${_vm.height}px` })},[_c('img',{attrs:{"alt":"Entity Icon","crossorigin":"anonymous","height":_vm.height,"src":_vm.src,"width":_vm.width}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }